import axios from "axios";
const { REACT_APP_KEY } = process.env;

export const sendMail = async (receiver, subject, sender, message) => {
  const key = REACT_APP_KEY;

  const options = {
    method: "POST",
    url: "https://rapidprod-sendgrid-v1.p.rapidapi.com/mail/send",
    headers: {
      "content-type": "application/json",
      "access-control-allow-origin": "*",
      "X-RapidAPI-Key": "4b946a6fd7msh072cd218e936673p139920jsnd496cdbde00c",
      "X-RapidAPI-Host": "rapidprod-sendgrid-v1.p.rapidapi.com",
    },
    data: `{"personalizations":[{"to":[{"email":"${receiver}"}],"subject":"${subject}"}],"from":{"email":"${sender}"},"content":[{"type":"text/plain","value":"${message}"}]}`,
  };
  const req = await axios
    .request(options)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      // console.log(error.code === "ERR_NETWORK");
      // console.error(error.message);
      if (error.code === "ERR_NETWORK") {
        return { status: 202 };
      }
    });
  return req;
};
